module.exports = __webpack_public_path__ + "img/获嘉首页金融服务.dfead0e8.png";